// @flow @format
import {connect} from 'react-redux';
import RepositorySelect from '../components/RepositorySelect';
import {selectRepository} from '../reducers/selection';

import type {State} from '../reducers';

const mapStateToProps = ({selection, entities}: State) => {
	return {
		repository: entities.repositories.entities[selection.repositoryId],
		repositories: entities.repositories.byMachine[selection.machineId],
	};
};

const mapDispatchToProps = {
	selectRepository,
};

export default connect(mapStateToProps, mapDispatchToProps)(RepositorySelect);



// WEBPACK FOOTER //
// ./src/containers/RepositorySelectContainer.js